import { defineStore } from "pinia";
import { useUserStore } from "./user";

import api from "@/api";

export const useWebSearchTopicStore = defineStore("web_search_topic", {
  state: () => ({
    loading: false,
    allDict: {},
    dropdownOptions: [],
  }),
  getters: {
    activeWebSearchTopics: (state) => {
      return Object.values(state.allDict).filter(topic => topic.is_deleted == false)
    },
    activeWebSearchTopicsDict: (state) => {
      return state.activeWebSearchTopics.reduce((dict, topic) => {
        dict[topic._id] = topic;
        return dict;
      }, {})
    }
  },
  actions: {
    /***
     * Fetch all web_search_topics for a specific organization
     */
    async fetchAll() {
      try {
        this.loading = true;
        // Fetch all web_search_topics
        const userStore = useUserStore()
        const activeOrganization = userStore.activeOrganization ?? null
        const res = await api.web_search_topic.fetchAll(activeOrganization);
        res.data = res.data.sort((a, b) => a.name.localeCompare(b.name));
        this.allDict = res.data.reduce((dict, web_search_topic) => {
          dict[web_search_topic._id] = web_search_topic;
          return dict;
        }, {});

        // Pre computing drop down options for any select component
        // in the select, we add the organization name if the user has access to several organizations

        this.dropdownOptions = Object.values(this.allDict).filter(topic => topic.is_deleted == false).map((topic) => {
          let label = topic.name;
          return {
            value: topic._id,
            text: label,
          };
        });
      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
});
